import React from 'react';
import './StatusBox.scss'

type Props = {
  status: string;
  type: 'warning' | 'off' | 'success';
}
const StatusBox = (props: Props) => {
  return (
    <div className={["status-box", props.type].join(' ')}>
      { props.status }
    </div>
  )
}

export default StatusBox;
